import { Component, OnInit, HostListener, ViewChild } from '@angular/core';
import { UploadDocumentComponent } from '../upload-document/upload-document.component';
import { Router } from '@angular/router';
import { read, utils } from 'xlsx';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import { HttpClient } from '@angular/common/http';
import { MenuItem } from 'primeng/api';
import { UserDashboardService } from 'src/app/services/user-dashboard.service';
import { CookieService } from 'ngx-cookie-service';
import { DataTransferService } from '../data-transfer.service';
import { StorageService } from 'src/app/services/storage.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CAT_EXECUTION_UPLOAD_CONSTANTS } from 'src/app/models/cat-execution-upload.constant';

@Component({
    selector: 'app-bulk-upload',
    templateUrl: './bulk-upload.component.html',
    styleUrls: ['./bulk-upload.component.scss'],
    standalone: false
})
export class BulkUploadComponent implements OnInit {
  @ViewChild(UploadDocumentComponent) uploadDocRef: UploadDocumentComponent;

  states: any;
  selectedState: any;
  showUploadDocuments: boolean = true;
  showEstampDetails: boolean = false;
  showEsignDetails: boolean = false;
  showConfirmation: boolean = false;

  //-------------------------Step Active --------------------------------------//
  active_product: boolean = false;
  active_eStamp: boolean = false;
  active_eSign: boolean = false;
  active_confirm: boolean = false;
  //-------------------Import & export variables ----------------------------//
  uploadDocumentsData: any;
  editTemplateData: any;
  estampData: any;
  esignData: any = { toBeEsigned: true };
  orderConfirmationData: any = { service: 'CAT-Edit' };
  uploadId!: string;
  addTemplateFields: any = [];
  userRole: string;
  ;
  selectedFile: any;
  sampleExcel!: string;
  headerData: any = [];
  secondRowData: any = [];
  fileUrl: string | undefined;
  fileName: string | undefined;
  onlyEstamp: boolean = false;
  onlyEsign: boolean = false;
  itemsCatEdit!: MenuItem[];
  displayBranch!: any;
  recieveTemplateData: any = [];
  showButton: boolean = true;
  currentStampType: string = '';
  //------------------------------------------------------------------------------//
  constructor(private storageService: StorageService, private router: Router, private modalService: NgbModal,
    private userDashboardService: UserDashboardService, private cookieService: CookieService,

    private http: HttpClient, private dataService: DataTransferService) {

    this.userRole = this.storageService.getRole() || null;

    this.itemsCatEdit = [
      {
        label: 'Both(Estamp & Esign)', icon: 'pi pi-info', command: () => {
          this.downloadSample('Cat-Upload');
        },
      },
      {
        label: 'EStamping', icon: 'pi pi-info', command: () => {
          this.downloadSample('E-Stamp');
        },
      },
      {
        label: 'ESigning', icon: 'pi pi-info', command: () => {
          this.downloadSample('E-Sign');
        },
      },
    ];
    this.userDashboardService.getBranchList().subscribe((res: any) => {
      this.states = res['content'];
      //this.displayBranch = this.cookieService.get('BranchName');
      this.displayBranch = this.storageService.getBranch() || null;
      this.displayBranch = this.displayBranch.name;


    })
  }

  ngOnInit() {
    this.recieveTemplateData = this.dataService.getData().fileds;
    if (this.recieveTemplateData != undefined) {
      this.addTemplateFields = [];
      this.recieveTemplateData.forEach((field: any) => {
        this.addTemplateFields.push(field.id_attribute);
      });
    } else {
      this.router.navigate(['doqfy/cat-edit/form']);
    }
  this.storageService.selectedStampProcessType$.subscribe(type => {
    this.currentStampType = type;
  });
  }

  @HostListener('window:beforeunload', ['$event'])
  handleBeforeUnload(event: Event) {
   
    event.preventDefault();
    event.returnValue = false;
  }

  changeState(data: any) {
    


  }

  onChange(url: RequestInfo | URL, fileName: string) {
    fetch(url)
      .then((response) => response.arrayBuffer())
      .then((data) => {
        const workbook = read(data, { type: 'array' });
        const worksheet = workbook.Sheets['Sheet1'];
        // Get the existing data from the sheet, including the header row
        const jsonData = utils.sheet_to_json(worksheet, { header: 1 });

        const newData = this.addTemplateFields;
        this.headerData = jsonData[0];

        // Payment Link & cc_emails bulk upload: inject 4 new optional columns into every cat-edit template
        const allFields: string[] = (this.headerData as string[]).concat(newData);
        const paymentCols = ['payee_name', 'payee_email', 'payee_contact', 'cc_emails'];
        paymentCols.forEach(col => { if (!allFields.includes(col)) allFields.push(col); });
        const fields = allFields;
        this.secondRowData = jsonData[1];
        const workbook1 = XLSX.utils.book_new();

        // Create a new worksheet
        const worksheet1 = XLSX.utils.json_to_sheet([], { header: fields });
        XLSX.utils.sheet_add_json(worksheet1, [this.secondRowData], { origin: 'A2', skipHeader: true });

        // Append new fields to the worksheet1
        XLSX.utils.sheet_add_aoa(worksheet1, [], { origin: -1 });
        // Add the worksheet1 to the workbook1
        XLSX.utils.book_append_sheet(workbook1, worksheet1, 'Sheet 1'); // Replace 'Sheet Name' with your desired sheet name
        const excelBuffer = XLSX.write(workbook1, { bookType: 'xlsx', type: 'array' });
        // Create a Blob from the buffer
        const blob = new Blob([excelBuffer], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        // Save the file using FileSaver.js
        FileSaver.saveAs(blob, fileName);

      });

  }

  downloadEditSample() { }

  downloadSample(value: string) {
   const isESBTR = this.currentStampType === CAT_EXECUTION_UPLOAD_CONSTANTS.ORDER_TYPE_ESBTR;
    if (value === 'Cat-Upload') {
      this.fileUrl = isESBTR 
      ? "assets/Sample_Files_Bulk_Upload/bulk_estamp_&_esign_esbtr - Edit.xlsx" 
      : "assets/Sample_Files_Bulk_Upload/bulk_estamp_&_esign - Edit.xlsx";
      this.fileName = 'bulk_estamp_&_esign.xlsx';
    } else if (value === 'E-Stamp') {
      this.fileUrl = isESBTR 
      ? "assets/Sample_Files_Bulk_Upload/bulk_estamps_esbtr.xlsx" 
      : "assets/Sample_Files_Bulk_Upload/bulk_estamps.xlsx";
      this.fileName = 'bulk_estamp.xlsx';
    } else {
      this.fileUrl = "assets/Sample_Files_Bulk_Upload/bulk_esign - Edit.xlsx";
      this.fileName = 'bulk_esign.xlsx';
    }
    this.onChange(this.fileUrl, this.fileName);
  }



  downExcelSample(fileUrl: any, fileName: any) {
    this.http.get(fileUrl, { responseType: 'blob' }).subscribe((response: Blob) => {
      const downloadLink = document.createElement('a');
      downloadLink.href = URL.createObjectURL(response);
      downloadLink.download = fileName;
      downloadLink.click();
    });
  }
  //-------------------Import & export Data from parent to child and vice-versa ----------------------------//

  onUploadDocsChange(data: any): void {
    this.uploadDocumentsData = data;
    if (this.uploadDocumentsData.option === 'In-complete') {

    } else {
      this.goToCatExecutionScreen('confirmation')
    }

  }

  onOrderConfirmationChange(data: any): void {
    this.orderConfirmationData = data;

  }

  //-------------------------------------------------------------------------------------------------//

  //-------- to Display the required component depending on the click of the stepper------------//

  goToCatExecutionScreen(value: string): void {
    this.showUploadDocuments = (value === 'uploadDocs');
    this.showConfirmation = (value === 'confirmation');
    this.setActiveTab(value);
  }

  //------------Change the color of the stepper on completion ------------------------------//

  setActiveTab(value: string) {
    if (value === 'uploadDocs') {
      this.active_product = false;
      this.active_confirm = false;
    } else {
      this.active_product = true;
      this.active_confirm = value === 'confirmation';
    }
  }


  gotoDashboard() {
    this.userRole === 'CLIENT' ? this.router.navigate(['doqfy/dashboard']) : this.router.navigate(['doqfy/admin-dashboard']);
  }

  back() {
    this.router.navigate(['doqfy/dashboard']);
  }
  getSelected() {
    this.cookieService.set('BranchName', this.selectedState);
    this.storageService.setBranch(this.selectedState)
  }


  getArticleCode(content: any) {
    this.modalService.open(content, {
      size: 'xl', ariaLabelledBy: 'modal-basic-title', backdrop: 'static', keyboard: false
    }).result.then((result) => {
      console.log(result);
    }, (reason) => {
      console.log(reason);
    });
  }

  closeModel() {

    this.modalService.dismissAll();
  }
}